// The checklist groups that have one overall photo on the pengecekan of the trip (gambar_depan / gambar_belakang).
// bagian_samping (kiri or kanan) and bagian_dalam have none that is certain, so they are not listed.
const groupFotoFields = {
  bagian_depan: "gambar_depan",
  bagian_belakang: "gambar_belakang",
};

// The Foto Asli of a problem: its own photo, otherwise the photo of the checklist row / audit row it came from, otherwise
// (checklist problem) the photo of its side of the vehicle taken in the pengecekan of that trip.
// null when there is none.
export const getProblemFoto = (problem) => {
  if (!problem) return null;
  if (problem.gambar) return problem.gambar;

  const pengecekanDetil = problem.data_pengecekan_mobil_detil;
  if (pengecekanDetil?.gambar) return pengecekanDetil.gambar;

  const auditDetil = problem.data_audit_kendaraan_detil;
  if (auditDetil?.gambar) return auditDetil.gambar;

  const fotoField = groupFotoFields[problem.label_grup];
  const pengecekan = pengecekanDetil?.data_pengecekan_mobil;
  if (fotoField && pengecekan?.[fotoField]) return pengecekan[fotoField];

  return null;
};

// the image button has something to show: a Foto Asli or a marker
export const hasProblemImage = (problem) =>
  !!getProblemFoto(problem) || !!problem?.marking_kordinat;
